
export enum UserSettingKey {
    OperationsDefaultView = 'operations.default.view',
    AllocationsDefaultView = 'allocations.default.view',
    AllocationsEmbeddedDefaultView = 'allocations.embedded.default.view',
    OpportunitiesDefaultView = 'opportunities.default.view',
    QuotesDefaultView = 'quotes.default.view',
    ProjectsDefaultView = 'projects.default.view',
    LeadsDefaultView = 'leads.default.view',
    DashboardsDefaultView = 'allocations.default.view',
    BackgroundImage = 'background.image',
    SchedulerDefaultResource = 'scheduler.default.resource',
    DashboardDefaultView = 'dashboard.default.view',
    RunsheetsDefaultView = 'runsheets.default.view',
    PaymentDefaultView = 'payment.default.view',
    ReconciliationDefaultView = 'reconciliation.default.view',
    SaleOrderDefaultView = 'sale.order.default.view',
    TaskDefaultView = 'task.default.view',
    TaskTemplateDefaultView = 'task.template.default.view',
    FilesDefaultView = 'files.default.view',
    SitesDefaultView = 'sites.default.view',
    ContractorDashboardDefaultView = 'contractor.dashboard.default.view',
    EmbeddedItemJobLevelView = 'embedded.item.job.level.view',
    EmbeddedItemStageLevelView = 'embedded.item.stage.level.view',
}

export interface UserSetting {
    _id: string;
    userId: string;
    key: UserSettingKey;
    value: any;
}
